<template>
    <client-only>
        <RecaptchaV2
            v-if="mounted"
            size="compact"
            @widget-id="handleWidgetId"
            @error-callback="handleErrorCallback"
            @expired-callback="handleExpiredCallback"
            @load-callback="handleLoadCallback"
        />
    </client-only>
</template>

<script setup lang="ts">
// https://www.npmjs.com/package/vue3-recaptcha-v2
import {RecaptchaV2, useRecaptcha} from 'vue3-recaptcha-v2';
const {handleReset} = useRecaptcha();

const props = defineProps(['field', 'onUpdate', 'success', 'error']);

let currentWidgetId: any = null;

const handleWidgetId = (widgetId: number) => {
    currentWidgetId = widgetId;
    console.log('Current recaptcha widgetID:', currentWidgetId);
};

const handleErrorCallback = () => {
    handleReset(currentWidgetId);
};

const handleExpiredCallback = () => {
    handleReset(currentWidgetId);
};

const handleLoadCallback = (response: unknown) => {
    props.onUpdate({field: props.field, value: response});
};

const mounted = ref(false);

onMounted(async () => {
    const recaptcha = usePluginRecaptcha();
    mounted.value = await recaptcha.init();
});

watch(
    () => props.success,
    (selection, prevSelection) => {
        handleReset(currentWidgetId);
    },
);

watch(
    () => props.error,
    (selection, prevSelection) => {
        handleReset(currentWidgetId);
    },
);
</script>
